import React, { useState } from "react";
import { FormGenerator } from "../../../../components";
import { NetWorkCallMethods, AlertProps } from "../../../../utils";
import { config } from "../../../../config";
import { NetworkCall } from "../../../../networkcall";
import { AlertContext } from "../../../../contexts";

const initial = {
  endDate: new Date(),
  Notes: "",
};
export const CloseActivity = (props) => {
  const { t } = (props)
  const [state, setState] = useState({ ...initial });
  const alert = React.useContext(AlertContext);

  const updateState = (key, value) => {
    setState({ ...state, [key]: value });
  };

  const sumbit = () => {
    const activity = {
      closed_on: state?.endDate,
      remarks: state?.Notes ?? "",
      status: "Closed",
      id: props?.id
    };

    NetworkCall(
      `${config.api_url}/lead_proxy/activity`,
      NetWorkCallMethods.post,
      {
        activity,
      },
      null,
      true,
      false
    )
      .then((response) => {
        props?.closeDialogFunction("close");
        props?.getActivityList(0, 10);
        alert.setSnack({
          ...alert,
          open: true,
          severity: AlertProps.severity.success,
          msg: t("Activity Closed successfully."),
        });
      })
      .catch((error) => {
        alert.setSnack({
          ...alert,
          open: true,
          severity: AlertProps.severity.error,
          msg: t("Internal error. Please try again later."),
        });
      });
  };

  return (
    <div style={{ padding: "24px" }}>
      <FormGenerator t={t}
        components={[
          {
            isActive: true,
            component: "datePickerWithTime",
            label: t("End Date & Time"),
            value: state?.endDate,
            placeholder: t("Select Visit Date & Time"),
            onChange: (value) => updateState("endDate", value),
            error: state?.error?.endDate,
            minDate: new Date(),
            is_popover:true,
            isRequired: true,
            size: {
              xs: 12,
              sm: 12,
              md: 12,
              lg: 12,
            },
          },
          {
            isActive: true,
            component: "text",
            label: t("Notes"),
            value: state?.Notes,
            placeholder: t("Notes"),
            onChange: (value) => updateState("Notes", value?.target?.value),
            error: state?.error?.Notes,
            isRequired: true,
            multiline: true,
            size: {
              xs: 12,
              sm: 12,
              md: 12,
              lg: 12,
            },
          },
          {
            isActive: true,
            component: "button",
            onClick: sumbit,
            label: t("Close"),
            size: {
              xs: 12,
            },
          },
        ]}
      />{" "}
    </div>
  );
};
